export default [
  { id: 'internal', text: 'Interna' },
  { id: 'outgoing', text: 'Externa' },
  { id: 'incoming', text: 'Entrante' }
];
